export default "__VITE_ASSET__1fce687f__"